module.exports = __webpack_public_path__ + "static/media/chandigarh.691f5d43.png";